import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import { createNamespacedHelpers } from "vuex";

const defaultCheckInSheet = () => ({
  id: 0,
  catalytic_converters: [],
  location: "",
  company_name: "",
  total_items: 0,
  avg_converter_price: 0,
  subtotal: 0,
  hst: 0,
  fixed_metals_prices: false,
});

const checkInSheet = {
  namespaced: true,
  state: {
    selectedCompany: "",
    converters: [],
    isFetchedOnce: false,
    isFetching: false,
    errors: null,
    currentCheckInSheet: defaultCheckInSheet(),
    checkInSheets: [],
    pageNumber: 1
  },
  mutations: {
    SET_PAGE_NUMBER(state, pageNumber) {
      state.pageNumber = pageNumber;
    },
    SET_SELECTED_COMPANY(state, company) {
      state.selectedCompany = company;
    },
    SET_CONVERTERS(state, converterList) {
      state.converters = converterList;
    },
    SET_ACTIVE_CHECK_IN_SHEET(state, sheet) {
      state.isFetching = false;
      state.currentCheckInSheet = sheet;
    },
    FETCH_CHECK_IN_SHEETS_SUCCESS(state, payload) {
      state.isFetchedOnce = true;
      state.isFetching = false;
      state.checkInSheets = payload;
    },
    FETCH_BEGIN(state) {
      state.isFetching = true;
    },
    FETCH_ERROR(state, error) {
      state.isFetching = false;
      state.error = error;
    },
    ADD_LATEST(state, payload) {
      state.checkInSheets.unshift(payload);
    },
    REMOVE_CHECK_IN_SHEET(state, id) {
      const index = state.checkInSheets.findIndex((sheet) => sheet.id == id);
      state.checkInSheets.splice(index, 1);
    },
  },
  actions: {
    changeCompany({ commit }, company) {
      commit("SET_SELECTED_COMPANY", company);
    },
    setConverterList({ commit }, converterList) {
      commit("SET_CONVERTERS", converterList);
    },
    async fetchCheckInSheet({ commit }, sheetId) {
      commit("FETCH_BEGIN");
      try {
        const sheet = extractDataAxios(await window.axios.get("/api/check-in-sheet/" + sheetId));
        commit("SET_ACTIVE_CHECK_IN_SHEET", sheet);
        commit("SET_CONVERTERS", sheet.catalytic_converters);
      } catch (err) {
        commit("FETCH_ERROR", extractErrorMessageAxios(err));
      }
    },
    async fetchCheckInSheets({ commit }) {
      commit("FETCH_BEGIN");
      try {
        const sheets = extractDataAxios(await window.axios.get("/api/check-in-sheet"));
        commit("FETCH_CHECK_IN_SHEETS_SUCCESS", sheets);
        // commit("SET_DEFAULT_CHECK_IN_SHEET");
      } catch (err) {
        commit("FETCH_ERROR", extractErrorMessageAxios(err));
      }
    },
    addCheckInSheet({ commit }, checkInSheet) {
      commit("ADD_LATEST", checkInSheet);
    },
    async deleteCheckInSheet({ commit }, id) {
      try {
        commit("REMOVE_CHECK_IN_SHEET", id);
        const response = extractDataAxios(await window.axios.delete(`/api/check-in-sheet/${id}`));
      } catch (err) {
        commit("FETCH_ERROR", extractErrorMessageAxios(err));
      }
    },
    async calculateTotals({ commit }, id) {
      try {
        const checkInSheet = extractDataAxios(await window.axios.get(`/api/sheet/${id}/calculate-totals`));
        commit("SET_ACTIVE_CHECK_IN_SHEET", checkInSheet);
        commit("SET_CONVERTERS", checkInSheet.catalytic_converters);
      } catch (e) {
        commit("FETCH_ERROR", extractErrorMessageAxios(e));
      }
    },
  },
};

const { mapState, mapActions, mapMutations } = createNamespacedHelpers("checkInSheet");

export { mapState, mapActions, mapMutations };

export default checkInSheet;
